import { render, staticRenderFns } from "./BasketBubble.vue?vue&type=template&id=ee907224&scoped=true"
import script from "./BasketBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketBubble.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BasketBubble.vue?vue&type=style&index=0&id=ee907224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee907224",
  null
  
)

export default component.exports